import FaqListener from './components/Faq/Faq';

const faqRows = [...document.querySelectorAll('.faq__group')];

for (let row of faqRows) {
  new FaqListener(row).init()
}
